import { getComparativeProductsByName } from '../lib/contestAndFixedPriceProjectProductsConfig';
import type { ProductNames } from '../lib/contestAndFixedPriceProjectProductsConfig';
import type { ComparativeProduct, ContestProduct, FixedPriceProjectProduct } from '../types';

export function useContestAndFixedPriceProjectProductsConfig(
    products: ContestProduct[] | FixedPriceProjectProduct[]
): ComparativeProduct[] {
    if (!products) return [];

    return products.map((product: ContestProduct | FixedPriceProjectProduct) => {
        const productFromConfig = getComparativeProductsByName(product.name as ProductNames);

        const title = productFromConfig.title !== '' ? productFromConfig.title : product.title;
        const description =
            productFromConfig.description !== ''
                ? productFromConfig.description
                : product.description;

        return {
            ...product,
            ...productFromConfig,
            pricing: product.pricing,
            title,
            description,
        };
    });
}
